import i18n from "../i18n";

export const STARTED = "_STARTED";
export const SUCCEEDED = "_SUCCEEDED";
export const FAILED = "_FAILED";
export const ENDED = "_ENDED";

export const getStarted = (state) => state + STARTED;
export const getSucceeded = (state) => state + SUCCEEDED;
export const getFailed = (state) => state + FAILED;
export const getEnded = (state) => state + ENDED;

export const statusEnum = Object.freeze({
  DEFAULT: "default",
  ERROR: "error",
  SUCCESS: "success",
});
export const PARTIAL_RESULT_FOUND = "PARTIAL_RESULT_FOUND";
// export const RECIPE_UPDATE_DUPLICATE_ITEM = "RECIPE_UPDATE_DUPLICATE_ITEM";
export const CHECK_FOR_TODAY_DATA = "CHECK_FOR_TODAY_DATA";
export const REPLACE_OR_ADD_RECIPE = "REPLACE_OR_ADD_RECIPE";
export const UPDATE_RECIPE_NAME = "UPDATE_RECIPE_NAME";
export const RESET_FORM = "RESET_FORM";
export const UPDATE_ITEM_CANCELED = "UPDATE_ITEM_CANCELED";
export const CHECK_USER_RECIPES = "CHECK_USER_RECIPES";
export const SHARE_SUCCESS_STATUS = "SHARE_SUCCESS_STATUS";
export const CONTRIBUTE_CATEGORY_SELECTED = "CONTRIBUTE_CATEGORY_SELECTED";
export const BARCODE_READ_IMG = "BARCODE_READ_IMG";
export const BARCODE_READ = "BARCODE_READ";
export const RECIPE_BARCODE_READ_IMG = "RECIPE_BARCODE_READ_IMG";
export const RECIPE_BARCODE_READ = "RECIPE_BARCODE_READ";
export const EDITSYMPTOM_EXPORT_DATE_CHANGED =
  "EDITSYMPTOM_EXPORT_DATE_CHANGED";
export const ON_CHANGE_ARCHIVE_FILTERS = "ON_CHANGE_ARCHIVE_FILTERS";
export const CONT_RESTAURANT_DEL_IMAGE = "CONT_RESTAURANT_DEL_IMAGE";
export const CONT_RESTAURANT_SUBMIT = "CONT_RESTAURANT_SUBMIT";
export const CONT_RESTAURANT_ADD_IMAGE = "CONT_RESTAURANT_ADD_IMAGE";
export const FORUM_LOAD_MORE = "FORUM_LOAD_MORE";
export const MESSAGE_PUBLISH_DRAFT = "MESSAGE_PUBLISH_DRAFT";
export const ON_CHANGE_FORGOT_PASSWORD_FORM = "ON_CHANGE_FORGOT_PASSWORD_FORM";
export const SELECTED_CATEGORY = "SELECTED_CATEGORY";
export const MESSAGE_FILTER = "MESSAGE_FILTER";
export const SELECTED_FOR_EDIT_MESSAGE = "SELECTED_FOR_EDIT_MESSAGE";
export const MESSAGE_SAVE_DRAFT = "MESSAGE_SAVE_DRAFT";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const MESSAGE_DELETE = "MESSAGE_DELETE";
export const MESSAGE_TOGGLE = "MESSAGE_TOGGLE";
export const ON_SUBMIT_MESSAGE = "ON_SUBMIT_MESSAGE";
export const GET_TRANSACTIONS_LIST = "GET_TRANSACTIONS_LIST";
export const ON_CHANGE_MESSAGE_FORM = "ON_CHANGE_MESSAGE_FORM";
export const MESSAGING_INITIALIZATION = "MESSAGING_INITIALIZATION";
export const CLEAR_DIRTY_DRAFT = "CLEAR_DIRTY_DRAFT";
export const PROFILE_LANGUAGE_SELECTED = "PROFILE_LANGUAGE_SELECTED";
export const SUB_USER_GRADUATE = "SUB_USER_GRADUATE";
export const ON_GRAPH_EXPORT = "ON_GRAPH_EXPORT";
export const SAVE_FEEDBACK_DRAFT = "SAVE_FEEDBACK_DRAFT";
export const RESET_FEEDBACK_PAGE = "RESET_FEEDBACK_PAGE";
export const ON_SUBMIT_FEEDBACK = "ON_SUBMIT_FEEDBACK";
export const ON_CHANGE_FEEDBACK_FORM = "ON_CHANGE_FEEDBACK_FORM";
export const INFO_AND_SUPPORT_INITIALIZATION =
  "INFO_AND_SUPPORT_INITIALIZATION";
export const EDITSYMPTOM_BODYMAP_START = "EDITSYMPTOM_BODYMAP_START";
export const EDITSYMPTOM_BODYMAP_RETURN = "EDITSYMPTOM_BODYMAP_RETURN";
export const DAILY_SUMMARY_DATE_CHANGED = "DAILY_SUMMARY_DATE_CHANGED";
export const DAILY_SUMMARY_USER_SELECTED = "DAILY_SUMMARY_USER_SELECTED";
export const GET_DAILY_SUMMARY_USERS = "GET_DAILY_SUMMARY_USERS";
export const RECIPE_FROM_BODYMAP = "RECIPE_FROM_BODYMAP";
export const RECIPE_TO_BODYMAP = "RECIPE_TO_BODYMAP";
export const DAILY_SUM_INITIALIZATION = "DAILY_SUM_INITIALIZATION";
export const CONT_CLEAR = "CONT_CLEAR";
export const CONT_SEND_DATA = "CONT_SEND_DATA";
export const CHECK_IS_DRAFT_DIRTY = "CHECK_IS_DRAFT_DIRTY";
export const CLEAR_CONT_DIRTY_DRAFT = "CLEAR_CONT_DIRTY_DRAFT";
export const CONT_INITIALIZATION = "CONT_INITIALIZATION";
export const CONT_BARCODE_READ = "CONT_BARCODE_READ";
export const CONTRIBUTE_GRAB_TEXT = "CONTRIBUTE_GRAB_TEXT";
export const SYMPTOM_FROM_BODYMAP = "SYMPTOM_FROM_BODYMAP";
export const GET_BODY_SYMPTOM = "GET_BODY_SYMPTOM";
export const GET_BODY_PARTS = "GET_BODY_PARTS";
export const BODY_MAP_INITIALIZATION = "BODY_MAP_INITIALIZATION";
export const INBOX_ACCEPT = "INBOX_ACCEPT";
export const INBOX_CATEGORY_SELECTED = "INBOX_CATEGORY_SELECTED";
export const INBOX_FILTER = "INBOX_FILTER";
export const INBOX_DELETE = "INBOX_DELETE";
export const INBOX_SELECT_TOGGLE = "INBOX_SELECT_TOGGLE";
export const INBOX_INGREDIENT_TOGGLE = "INBOX_INGREDIENT_TOGGLE";
export const INBOX_INITIALIZATION = "INBOX_INITIALIZATION";
export const ON_SHARE = "ON_SHARE";
export const ON_CHANGE_SHARE = "ON_CHANGE_SHARE";
export const ON_CHANGE_SIGNUP_FORM = "ON_CHANGE_SIGNUP_FORM";
export const SYMPTOM_EXPORT = "SYMPTOM_EXPORT";
export const ON_SUBMIT_MEALPLANMODAL = "ON_SUBMIT_MEALPLANMODAL";
export const ON_CHANGE_MEALPLANMODAL = "ON_CHANGE_MEALPLANMODAL";
export const LOGIN_SET_DEFAULT = "LOGIN_SET_DEFAULT";
export const ACTIVE_USER = "ACTIVE_USER";
export const LOGIN_SUBMIT = "LOGIN_SUBMIT";
export const FORGOT_PASSWORD_SET_DEFAULT = "FORGOT_PASSWORD_SET_DEFAULT";
export const FORGOT_PASSWORD_SUBMIT = "FORGOT_PASSWORD_SUBMIT";
export const FORGOT_PASSWORD_RESET_SET_DEFAULT =
  "FORGOT_PASSWORD_RESET_SET_DEFAULT";

export const CLOSE_MODAL = "CLOSE_MODAL";
export const FORGOT_PASSWORD_RESET_SUBMIT = "FORGOT_PASSWORD_RESET_SUBMIT";
export const RESET_PASSWORD_DEFAULT = "RESET_PASSWORD_DEFAULT";
export const RESET_PASSWORD_SUBMIT = "RESET_PASSWORD_SUBMIT";
export const RESET_PASSWORD_SUBMIT_VALIDATION =
  "RESET_PASSWORD_SUBMIT_VALIDATION";
export const SIGN_UP_DEFAULT = "SIGN_UP_DEFAULT";
export const SIGN_UP_INITIALIZATION = "SIGN_UP_INITIALIZATION";
export const SIGN_UP_SUBMIT = "SIGN_UP_SUBMIT";
export const SIGN_UP_SUBMIT_VALIDATION = "SIGN_UP_SUBMIT_VALIDATION";
export const PROFILE_DEFAULT = "PROFILE_DEFAULT";
export const PROFILE_GET_USER_AND_SUBUSERS = "PROFILE_GET_USER_AND_SUBUSERS";
export const PROFILE_SUBMIT = "PROFILE_SUBMIT";
export const PROFILE_UPDATE_DEFAULT = "PROFILE_UPDATE_DEFAULT";
export const PROFILE_UPDATE_INITIALIZATION = "PROFILE_UPDATE_INITIALIZATION";
export const PROFILE_UPDATE_GET_USER = "PROFILE_UPDATE_GET_USER";
export const PROFILE_UPDATE_SUBMIT = "PROFILE_UPDATE_SUBMIT"; //USER_EDIT_SELECTED
export const PROFILE_EDIT_SELECTED = "PROFILE_EDIT_SELECTED";
export const PROFILE_LIST_RESET = "PROFILE_LIST_RESET";
export const PROFILE_OPTION_SELECTED = "PROFILE_OPTION_SELECTED";
export const CLEAR_PROMPT = "CLEAR_PROMPT";
export const CHANGE_PASSWORD_DEFAULT = "CHANGE_PASSWORD_DEFAULT";
export const CHANGE_PASSWORD_SUBMIT = "CHANGE_PASSWORD_SUBMIT";
export const ON_CHANGE_PROFILE_FORM = "ON_CHANGE_PROFILE_FORM";
export const CHANGE_PASSWORD_SUBMIT_VALIDATION =
  "CHANGE_PASSWORD_SUBMIT_VALIDATION";
export const SUB_USER_CREATE_DEFAULT = "SUB_USER_CREATE_DEFAULT";
export const SUB_USER_INITIALIZATION = "SUB_USER_INITIALIZATION";
export const SUB_USER_CREATE_SUBMIT = "SUB_USER_CREATE_SUBMIT";
export const SUB_USER_DELETE_SUBMIT = "SUB_USER_DELETE_SUBMIT";
export const SUB_USER_DELETE_SUBMIT_UNSUCCESS =
  "SUB_USER_DELETE_SUBMIT_UNSUCCESS";
export const USER_DELETE_SUBMIT = "USER_DELETE_SUBMIT";
export const RECIPE_MANAGEMENT_INITIALIZATION =
  "RECIPE_MANAGEMENT_INITIALIZATION";
export const RECIPE_MANAGEMENT_INGREDIENT_TOGGLE =
  "RECIPE_MANAGEMENT_INGREDIENT_TOGGLE";
export const RECIPE_MANAGEMENT_INGREDIENT_FILTER =
  "RECIPE_MANAGEMENT_INGREDIENT_FILTER";
export const RECIPE_MANAGEMENT_RECIPE_SELECT_TOGGLE =
  "RECIPE_MANAGEMENT_RECIPE_SELECT_TOGGLE";
export const RECIPE_MANAGEMENT_DELETE = "RECIPE_MANAGEMENT_DELETE";
export const RECIPE_INITIALIZATION = "RECIPE_INITIALIZATION";
export const KIT_INITIALIZATION = "KIT_INITIALIZATION";
export const KIT_CATEGORY_SELECTED = "KIT_CATEGORY_SELECTED";
export const SYMPTOM_KIT_ADD = "SYMPTOM_KIT_ADD";
export const RECIPE_CATEGORY_SELECTED = "RECIPE_CATEGORY_SELECTED";
export const RECIPE_ADD_ITEM = "RECIPE_ADD_ITEM";
export const RECIPE_EDIT_SELECTED = "RECIPE_EDIT_SELECTED";
export const RECIPE_SAVE_ITEM = "RECIPE_SAVE_ITEM";
export const RECIPE_DELETE = "RECIPE_DELETE";
export const RESET_ID = "RESET_ID";
export const RECIPE_SAVE = "RECIPE_SAVE";
export const RECIPE_CLEAR = "RECIPE_CLEAR";
export const GET_RECIPE_DETAIL = "GET_RECIPE_DETAIL";
export const SEARCH_INGREDIENTS = "SEARCH_INGREDIENTS";
export const SEARCH_RECIPES = "SEARCH_RECIPES";
export const COMMIT_TYPED_RECIPE_NAME = "COMMIT_TYPED_RECIPE_NAME";
export const SEARCH_RECIPES_SUGGESTIONS_STARTED  = "SEARCH_RECIPES_SUGGESTIONS_STARTED";
export const SEARCH_RECIPES_SUGGESTIONS_FINISHED = "SEARCH_RECIPES_SUGGESTIONS_FINISHED";
export const ON_CHANGE_INGREDIENTFORM = "ON_CHANGE_INGREDIENTFORM";
export const ON_CHANGE_MYRECIPENTFORM = "ON_CHANGE_MYRECIPENTFORM";
export const INGREDIENT_OPTION_SELECTED = "INGREDIENT_OPTION_SELECTED";
export const INGREDIENT_KIT_SELECTED = "INGREDIENT_KIT_SELECTED";
export const INGREDIENT_KIT_ADDED = "INGREDIENT_KIT_ADDED";
export const INGREDIENT_KIT_UPDATED = "INGREDIENT_KIT_UPDATED";
export const GET_RECIPE = "GET_RECIPE";
export const RECIPE_CREATE_CUISINE = "RECIPE_CREATE_CUISINE";
export const RECIPE_CREATE_MEASUREMENT = "RECIPE_CREATE_MEASUREMENT";
export const RECIPE_MANAGEMENT_UPDATE_RATING =
  "RECIPE_MANAGEMENT_UPDATE_RATING";
export const RECIPE_MANAGEMENT_UPDATE_RANK = "RECIPE_MANAGEMENT_UPDATE_RANK";
export const GET_STOCKS = "GET_STOCKS";
export const GET_DETAIL_STOCKS = "GET_DETAIL_STOCKS";
export const GET_STOCK_INFO = "GET_STOCK_INFO";
export const SWIPE_STOCKS = "SWIPE_STOCKS";
export const DELETE_STOCK = "DELETE_STOCK";
export const ADD_STOCK = "ADD_STOCK";
export const RESET_STOCK_PAGE_MYDATA = "RESET_STOCK_PAGE_MYDATA";
export const ORDER_STOCK = "ORDER_STOCK";
export const SELECT_STOCK_ITEM = "SELECT_STOCK_ITEM";
export const SELECT_TIME_SELECTION = "SELECT_TIME_SELECTION";
export const GRAPH_INITIALIZATION = "GRAPH_INITIALIZATION";
export const GRAPH_INITIALIZATION_FAILED = "GRAPH_INITIALIZATION_FAILED";
export const UPDATE_BIG_GRAPH = "UPDATE_BIG_GRAPH";
export const ON_CHANGE_ANALYZEFORM = "ON_CHANGE_ANALYZEFORM";
export const ON_CHANGE_FACTOR_ANALYZEFORM = "ON_CHANGE_FACTOR_ANALYZEFORM";
export const ANALYZEPAGE_DATE_CHANGED = "ANALYZEPAGE_DATE_CHANGED";
export const RESET_ANALYZE_PAGE = "RESET_ANALYZE_PAGE";
export const ON_CHANGE_USER_ANALYZEFORM = "ON_CHANGE_USER_ANALYZEFORM";
export const TOGGLE_SEVERITY = "TOGGLE_SEVERITY";
export const GET_DASHBOARD_USERS = "GET_DASHBOARD_USERS";
export const RESET_VIEWSUMMARY_PAGE_MYDATA = "RESET_VIEWSUMMARY_PAGE_MYDATA";
export const GET_SYMPTOM_USERS = "GET_SYMPTOM_USERS";
export const GET_EDIT_SYMPTOM_USERS = "GET_EDIT_SYMPTOM_USERS";
export const SYMPTOM_USER_SELECTED = "SYMPTOM_USER_SELECTED";
export const SYMPTOM_CATEGORY_SELECTED = "SYMPTOM_CATEGORY_SELECTED";
export const EDIT_SYMPTOM_CATEGORY_SELECTED = "EDIT_SYMPTOM_CATEGORY_SELECTED";
export const CLEAR_SYMPTOM = "CLEAR_SYMPTOM";
export const SEARCH_SYMPTOM_OPTIONS = "SEARCH_SYMPTOM_OPTIONS";
export const EDIT_PAGE_SEARCH_SYMPTOM_OPTIONS =
  "EDIT_PAGE_SEARCH_SYMPTOM_OPTIONS";
export const ON_CHANGE_SYMPTOMFORM = "ON_CHANGE_SYMPTOMFORM";
export const SAVE_FOOD_AND_SYMPTOMS = "SAVE_FOOD_AND_SYMPTOMS";
export const SYMPTOMS_ITEM_SELECT = "SYMPTOMS_ITEM_SELECT";
export const SYMPTOMS_ITEM_UPDATE = "SYMPTOMS_ITEM_UPDATE";
export const RESET_INPUT_PAGE = "RESET_INPUT_PAGE";
export const RESET_CONTRIBUTE_ALERT_STATE = "RESET_CONTRIBUTE_ALERT_STATE";
export const RECIPE_ITEM_SELECT = "RECIPE_ITEM_SELECT";
export const SYMPTOMS_ITEM_DELETE = "SYMPTOMS_ITEM_DELETE";
export const SYMPTOM_DATE_CHANGED = "SYMPTOM_DATE_CHANGED";
export const EDIT_SYMPTOM_DATE_CHANGED = "EDIT_SYMPTOM_DATE_CHANGED";
export const SYMPTOM_DATE_RANGE_CHANGED = "SYMPTOM_DATE_RANGE_CHANGED";
export const GET_SYMPTOM_LIST = "GET_SYMPTOM_LIST";
export const SYMPTOM_SELECTED = "SYMPTOM_SELECTED";
export const SYMPTOM_DELETED = "SYMPTOM_DELETED";
export const SYMPTOM_OPTION_SELECTED = "SYMPTOM_OPTION_SELECTED";
export const SYMPTOM_FROM_CONT = "SYMPTOM_FROM_CONT";
export const SYMPTOM_KIT_SELECTED = "SYMPTOM_KIT_SELECTED";

export const CREATE_SYMPTOM = "CREATE_SYMPTOM";
export const INPUT_ADD_ITEM = "INPUT_ADD_ITEM";
export const ADD_GREY_UPC_ITEM_NAME_FIELD = "ADD_GREY_UPC_ITEM_NAME_FIELD";
export const UPDATE_SYMPTOM = "UPDATE_SYMPTOM";
export const ON_CHANGE_SYMPTOMEDITFORM = "ON_CHANGE_SYMPTOMEDITFORM";
export const ON_CHANGE_SEARCHFORM = "ON_CHANGE_SEARCHFORM";
export const SYMPTOM_SEARCH_DATE_CHANGED = "SYMPTOM_SEARCH_DATE_CHANGED";
export const RESET_EDIT_PAGE = "RESET_EDIT_PAGE";
export const ON_SAVE_PAGE_SYMPTOMEDITFORM = "ON_SAVE_PAGE_SYMPTOMEDITFORM";
export const EDITSYMPTOM_CHANGER_SEARCHFORM = "EDITSYMPTOM_CHANGER_SEARCHFORM";
export const EDIT_SYMPTOM_OPTION_SELECTED = "EDIT_SYMPTOM_OPTION_SELECTED";
export const SET_RECIPE_MANAGEMENT_FORM = "SET_RECIPE_MANAGEMENT_FORM";

export const PRODUCT_INITIALIZATION = "PRODUCT_INITIALIZATION";
export const PRODUCT_ADD_ITEM = "PRODUCT_ADD_ITEM";
export const PRODUCT_EDIT_SELECTED = "PRODUCT_EDIT_SELECTED";
export const PRODUCT_SAVE_ITEM = "PRODUCT_SAVE_ITEM";
export const PRODUCT_DELETE = "PRODUCT_DELETE";
export const PRODUCT_SAVE = "PRODUCT_SAVE";
export const PRODUCT_CLEAR = "PRODUCT_CLEAR";
export const GET_PRODUCT = "GET_PRODUCT";
export const PRODUCT_CATEGORY_SELECTED = "PRODUCT_CATEGORY_SELECTED";
export const ON_CHANGE_PRODUCT = "ON_CHANGE_PRODUCT";
export const UPC_NOT_IN_PRODUCT = "UPC_NOT_IN_PRODUCT";
export const ON_CHANGE_INGREDIENTFORM_PRODUCT =
  "ON_CHANGE_INGREDIENTFORM_PRODUCT";
export const ON_SELECT_INGREDIENNAME_PRODUCT =
  "ON_SELECT_INGREDIENNAME_PRODUCT";
export const SEARCH_PRODUCTS = "SEARCH_PRODUCTS";
export const SEARCH_BRANDS = "SEARCH_BRANDS";
export const SEARCH_PRODUCT_INGREDIENTS = "SEARCH_PRODUCT_INGREDIENTS";
export const MEAL_PLANNER_INITIALIZATION = "MEAL_PLANNER_INITIALIZATION";
export const ON_CHANGE_MEALPLANNERFORM = "ON_CHANGE_MEALPLANNERFORM";
export const ADD_NEW_FOOD_MEAL_PLANNER = "ADD_NEW_FOOD_MEAL_PLANNER";
export const MEAL_ITEM_CLICK_MEALPALNNER = "MEAL_ITEM_CLICK_MEALPALNNER";
export const MEAL_PLAN_SUMMARY_INITIALIZATION =
  "MEAL_PLAN_SUMMARY_INITIALIZATION";
export const MEAL_PLAN_SUMMARY_CHANGE_DATE = "MEAL_PLAN_SUMMARY_CHANGE_DATE";
export const EXTEND_MEAL_PLAN_SUMMARY = "EXTEND_MEAL_PLAN_SUMMARY";
export const ON_DROP_PLAN_SUMMARY = "ON_DROP_PLAN_SUMMARY";
export const MOVE_GRID_PLAN_SUMMARY = "MOVE_GRID_PLAN_SUMMARY";
export const DELETE_FOOD_MEAL_PLANNER = "DELETE_FOOD_MEAL_PLANNER";
export const ADD_UPDATE_MEAL_PLANNER = "ADD_UPDATE_MEAL_PLANNER";
export const LIST_COMBINE_MEAL_PLANNER = "LIST_COMBINE_MEAL_PLANNER";
export const TOGGLE_UNSAVE_MESSAGE = "TOGGLE_UNSAVE_MESSAGE";
export const FORUM_INSERT = "FORUM_INSERT";
export const FORUM_INITIALIZATION = "FORUM_INITIALIZATION";
export const CLEAR_FORUM = "CLEAR_FORUM";
export const FORUM_ARCHIVE_INITIALIZATION = "FORUM_ARCHIVE_INITIALIZATION";
export const FORUM_SINGLE_INITIALIZATION = "FORUM_SINGLE_INITIALIZATION";
export const ON_CHANGE_FORUM_FILTERS = "ON_CHANGE_FORUM_FILTERS";
export const RE_GET_FORUM_FILTERS = "RE_GET_FORUM_FILTERS";
export const FORUM_SELECT_FOR_EDIT_POST = "FORUM_SELECT_FOR_EDIT_POST";
export const FORUM_DO_ARCHIVE = "FORUM_DO_ARCHIVE";
export const FORUM_RELEVANT = "FORUM_RELEVANT";
export const FORUM_REMOVE_ARCHIVE = "FORUM_REMOVE_ARCHIVE";
export const FORUM_CANCEL_POST = "FORUM_CANCEL_POST";
export const FORUM_ON_CHANGE_STATE = "FORUM_ON_CHANGE_STATE";
export const FORUM_DELETE_POST = "FORUM_DELETE_POST";
export const CLEAR_MEALPLANNER_FORM = "CLEAR_MEALPLANNER_FORM";
export const GET_ITEM_DETAILS = "GET_ITEM_DETAILS";
export const ON_CHANGE_ALERT_STATUS = "ON_CHANGE_ALERT_STATUS";
export const ON_SELECT_ITEM_TO_DELETE = "ON_SELECT_ITEM_TO_DELETE";
export const CLEAR_EDIT_SYMPTOMS = "CLEAR_EDIT_SYMPTOMS";
export const CLEAR_REGIMEN = "CLEAR_REGIMEN";
export const CLEAR_EDIT_REGIMEN = "CLEAR_EDIT_REGIMEN";
export const CLEAR_MEAL_PLAN = "CLEAR_MEAL_PLAN";
export const CLEAR_INBOX = "CLEAR_INBOX";
export const CLEAR_PLANNER = "CLEAR_PLANNER";
export const ON_SEARCH_POSTS = "ON_SEARCH_POSTS";

export const EDIT_PAGE_BARCODE_READ_IMG = "EDIT_PAGE_BARCODE_READ_IMG";
export const EDIT_PAGE_BARCODE_READ = "EDIT_PAGE_BARCODE_READ";

export const RECIPE_PAGE_BARCODE_READ_IMG = "RECIPE_PAGE_BARCODE_READ_IMG";
export const RECIPE_PAGE_BARCODE_READ = "RECIPE_PAGE_BARCODE_READ";

export const MEAL_PLAN_PAGE_BARCODE_READ_IMG = "MEAL_PLAN_PAGE_BARCODE_READ_IMG";
export const MEAL_PLAN_PAGE_BARCODE_READ = "MEAL_PLAN_PAGE_BARCODE_READ";
export const SET_HHMM_MODE = "SET_HHMM_MODE";
export const RECALC_REQUEST = "RECALC_REQUEST";
export const RECALC_SUCCESS = "RECALC_SUCCESS";
export const CLEAR_RECALC_SUCCESS = "CLEAR_RECALC_SUCCESS";
export const RECALC_FAILURE = "RECALC_FAILURE";
export const HISTORY_SUGGESTIONS_STARTED  = "HISTORY_SUGGESTIONS_STARTED";
export const HISTORY_SUGGESTIONS_SUCCESS  = "HISTORY_SUGGESTIONS_SUCCESS";
export const HISTORY_SUGGESTIONS_FAILED   = "HISTORY_SUGGESTIONS_FAILED";
export const HISTORY_SUGGESTIONS_CLEAR = "HISTORY_SUGGESTIONS_CLEAR";
export const DISMISS_SAVE_SUCCESS = "DISMISS_SAVE_SUCCESS";
export const DISMISS_EDIT_SAVE_SUCCESS = "DISMISS_EDIT_SAVE_SUCCESS";
export const RESET_MODAL = "RESET_MODAL";
export const MEAL_PLANNER_SET_LOADING = "MEAL_PLANNER_SET_LOADING";

function get_array(from, to) {
  let rlt = [];
  for (let i = from; i <= to; i++) rlt.push(i);
  return rlt;
}
export function SYMPTOM_UNITS_NEW() {
  let units = i18n.t("SYMPTOM_UNITS_NEW", {
    returnObjects: true,
  });
  return units;
}
export function ACTIVITY_UNITS() {
  let units = i18n.t("ACTIVITY_UNITS", {
    returnObjects: true,
  });
  return units;
}
export function FOOD_UNITS() {
  let units = i18n.t("FOOD_UNITS", {
    returnObjects: true,
  });
  return units;
}
export function PCP_UNITS() {
  let units = i18n.t("PCP_UNITS", {
    returnObjects: true,
  });
  return units;
}
export function DRUG_UNITS() {
  let units = i18n.t("DRUG_UNITS", {
    returnObjects: true,
  });
  return units;
}
export function SUP_UNITS() {
  let units = i18n.t("SUP_UNITS", {
    returnObjects: true,
  });
  return units;
}
export function LOC_UNITS() {
  let units = i18n.t("LOC_UNITS", {
    returnObjects: true,
  });
  return units;
}
export function KIT_CAT() {
  let units = i18n.t("KIT_CAT", {
    returnObjects: true,
  });
  return units;
}
export function INBOX_CAT() {
  let units = i18n.t("INBOX_CAT", {
    returnObjects: true,
  });
  return units;
}
export function USER_GROUP() {
  let units = i18n.t("USER_GROUP", {
    returnObjects: true,
  });
  return units;
}
export function IS_UNSAVED(flag = false) {
  let status = localStorage.getItem("dataChanged");
  if (flag) {
    localStorage.setItem("dataChanged", flag);
  } else {
    return status;
  }
}

export function Unsaved_Data_Checker(vAlertMessages = {}) {
  let status = localStorage.getItem("unsavedAlertData");
  if (vAlertMessages.title && vAlertMessages.title !== "") {
    localStorage.setItem("unsavedAlertData", JSON.stringify(vAlertMessages));
  } else {
    localStorage.removeItem("unsavedAlertData");
  }
}

export const USER_LANG = [
  { label: "English", value: "1200000000001000022", code: "en-US" },
  { label: "Chinese (Simplified)", value: "1200000000001000015", code: "zh-CN" },
  { label: "Chinese (Traditional)", value: "1200000000001000016", code: "zh-TW" },
  // { label: "Afrikaans", value: "1200000000001000001" },
  // { label: "Shqiptare", value: "1200000000001000002" },
  // { label: "አማርኛ", value: "1200000000001000003" },
  // { label: "عربى", value: "1200000000001000004" },
  // { label: "հայերեն", value: "1200000000001000005" },
  // { label: "Azərbaycan dili", value: "1200000000001000006" },
  // { label: "Euskara", value: "1200000000001000007" },
  // { label: "Беларуская", value: "1200000000001000008" },
  // { label: "বাংলা", value: "1200000000001000009" },
  // { label: "Bosanski", value: "1200000000001000010" },
  // { label: "български", value: "1200000000001000011" },
  // { label: "Català", value: "1200000000001000012" },
  // { label: "Sugbuanon", value: "1200000000001000013" },
  // { label: "Chichewa", value: "1200000000001000014" },
  // { label: "中文(简体)", value: "1200000000001000015" },
  // { label: "中文(繁體)", value: "1200000000001000016" },
  // { label: "Corsu", value: "1200000000001000017" },
  // { label: "Hrvatski", value: "1200000000001000018" },
  // { label: "češti", value: "1200000000001000019" },
  // { label: "dansk", value: "1200000000001000020" },
  // { label: "Nederlands", value: "1200000000001000021" },
  // { label: "English", value: "1200000000001000022" },
  // { label: "Esperanto", value: "1200000000001000023" },
  // { label: "Eestlane", value: "1200000000001000024" },
  // { label: "Pilipino", value: "1200000000001000025" },
  // { label: "Suomalainen", value: "1200000000001000026" },
  // { label: "français", value: "1200000000001000027" },
  // { label: "Frysk", value: "1200000000001000028" },
  // { label: "Galego", value: "1200000000001000029" },
  // { label: "ქართველი", value: "1200000000001000030" },
  // { label: "Deutsche", value: "1200000000001000031" },
  // { label: "Ελληνικά", value: "1200000000001000032" },
  // { label: "ગુજરાતી", value: "1200000000001000033" },
  // { label: "Kreyòl ayisyen", value: "1200000000001000034" },
  // { label: "Hausa", value: "1200000000001000035" },
  // { label: "Ōlelo Hawaiʻi", value: "1200000000001000036" },
  // { label: "עִברִית", value: "1200000000001000037" },
  // { label: "हिंदी", value: "1200000000001000038" },
  // { label: "Hmong", value: "1200000000001000039" },
  // { label: "Magyar", value: "1200000000001000040" },
  // { label: "Íslenska", value: "1200000000001000041" },
  // { label: "Igbo", value: "1200000000001000042" },
  // { label: "bahasa Indonesia", value: "1200000000001000043" },
  // { label: "Gaeilge", value: "1200000000001000044" },
  // { label: "italiano", value: "1200000000001000045" },
  // { label: "日文", value: "1200000000001000046" },
  // { label: "Wong jawa", value: "1200000000001000047" },
  // { label: "ಕನ್ನಡ", value: "1200000000001000048" },
  // { label: "Қазақ", value: "1200000000001000049" },
  // { label: "ខ្មែរ", value: "1200000000001000050" },
  // { label: "Kinyarwanda", value: "1200000000001000051" },
  // { label: "한국어", value: "1200000000001000052" },
  // { label: "Kurdî (Kurmancî)", value: "1200000000001000053" },
  // { label: "Кыргызча", value: "1200000000001000054" },
  // { label: "ລາວ", value: "1200000000001000055" },
  // { label: "Latine", value: "1200000000001000056" },
  // { label: "Latvietis", value: "1200000000001000057" },
  // { label: "Lietuvis", value: "1200000000001000058" },
  // { label: "Lëtzebuergesch", value: "1200000000001000059" },
  // { label: "Македонски", value: "1200000000001000060" },
  // { label: "Malagasy", value: "1200000000001000061" },
  // { label: "Bahasa Melayu", value: "1200000000001000062" },
  // { label: "മലയാളം", value: "1200000000001000063" },
  // { label: "Malti", value: "1200000000001000064" },
  // { label: "Maori", value: "1200000000001000065" },
  // { label: "मराठी", value: "1200000000001000066" },
  // { label: "Монгол", value: "1200000000001000067" },
  // { label: "မြန်မာ (မြန်မာ)", value: "1200000000001000068" },
  // { label: "नेपाली", value: "1200000000001000069" },
  // { label: "norsk", value: "1200000000001000070" },
  // { label: "ଓଡିଆ (ଓଡିଆ)", value: "1200000000001000071" },
  // { label: "پښتو", value: "1200000000001000072" },
  // { label: "فارسی", value: "1200000000001000073" },
  // { label: "Polskie", value: "1200000000001000074" },
  // { label: "Português", value: "1200000000001000075" },
  // { label: "ਪੰਜਾਬੀ", value: "1200000000001000076" },
  // { label: "Română", value: "1200000000001000077" },
  // { label: "русский", value: "1200000000001000078" },
  // { label: "Faasamoa", value: "1200000000001000079" },
  // { label: "Gàidhlig  h-Alba", value: "1200000000001000080" },
  // { label: "Српски", value: "1200000000001000081" },
  // { label: "Sesotho", value: "1200000000001000082" },
  // { label: "Sho", value: "1200000000001000083" },
  // { label: "سنڌي", value: "1200000000001000084" },
  // { label: "සිංහල", value: "1200000000001000085" },
  // { label: "Slovák", value: "1200000000001000086" },
  // { label: "Slovenšči", value: "1200000000001000087" },
  // { label: "Soomaali", value: "1200000000001000088" },
  // { label: "Español", value: "1200000000001000089" },
  // { label: "Sundanis", value: "1200000000001000090" },
  // { label: "Kiswahili", value: "1200000000001000091" },
  // { label: "svenska", value: "1200000000001000092" },
  // { label: "Тоҷикӣ", value: "1200000000001000093" },
  // { label: "தமிழ்", value: "1200000000001000094" },
  // { label: "Татар", value: "1200000000001000095" },
  // { label: "తెలుగు", value: "1200000000001000096" },
  // { label: "ไทย", value: "1200000000001000097" },
  // { label: "Türk", value: "1200000000001000098" },
  // { label: "Türkmenler", value: "1200000000001000099" },
  // { label: "Український", value: "1200000000001000100" },
  // { label: "اردو", value: "1200000000001000101" },
  // { label: "ئۇيغۇر", value: "1200000000001000102" },
  // { label: "O'zbek", value: "1200000000001000103" },
  // { label: "Tiếng Việt", value: "1200000000001000104" },
  // { label: "Cymraeg", value: "1200000000001000105" },
  // { label: "isiXhosa", value: "1200000000001000106" },
  // { label: "יידיש", value: "1200000000001000107" },
  // { label: "Yoruba", value: "1200000000001000108" },
  // { label: "Zulu", value: "1200000000001000109" },
];

export const FIELD_MAP      = { 3: 'user', 4: 'category', 6: 'to' };
export const NEG_RESET_MAP  = { 2: 'to', 3: 'user', 4: 'category', 5: 'start', 6: 'to' };



// WEBPACK FOOTER //
// ./src/actions/constant.js